import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  BulkImportError,
  BulkImportResult,
  GameService
} from '../../services/game.service';

@Component({
  selector: 'app-bulk-import-dialog',
  templateUrl: './bulk-import-dialog.component.html',
  styleUrls: ['./bulk-import-dialog.component.css']
})
export class BulkImportDialogComponent {
  @ViewChild('fileInput', { static: true })
  fileInput: ElementRef<HTMLInputElement>;

  loading = false;
  error: string | null = null;
  validationErrors: BulkImportError[] = [];
  fileName: string | null = null;
  selectedFile: File | null = null;

  readonly csvTemplate = [
    [
      'Venue Date',
      'Venue Time',
      'Venue Name',
      'Venue Timezone',
      'League short name',
      'Home Team',
      'Home Team League Short Name',
      'Away Team',
      'Away Team League Short Name',
      'Season',
      'Season Type',
      'ID Type',
      'Billing Month',
      'DC Date',
      'DC Time',
      'ETC Date',
      'ETC Time',
      'Region',
      'DC Type',
      'DC Subtype'
    ].join(','),
    [
      '2026-01-22',
      '02:00',
      'Swiss Life Arena',
      'Europe/Zurich',
      '11U-AAA',
      'TEST',
      '',
      'TEST',
      '',
      '2026',
      'Regular',
      'Master',
      '2026-01',
      '2026-01-22',
      '18:00',
      '2026-01-23',
      '10:00',
      'EU',
      'PV',
      'Full'
    ].join(',')
  ].join('\n');

  constructor(
    private dialogRef: MatDialogRef<BulkImportDialogComponent>,
    private gameService: GameService
  ) {}

  onFileSelected(event: Event) {
    if (this.loading) {
      return;
    }
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];
    this.fileName = file.name;
    this.validationErrors = [];
    this.error = null;
    this.selectedFile = file;
  }

  clearSelectedFile() {
    this.selectedFile = null;
    this.fileName = null;
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }
  }

  downloadTemplate() {
    const blob = new Blob([this.csvTemplate], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'games_import_template.csv';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  async import() {
    if (!this.selectedFile) {
      this.error = 'No CSV file selected';
      return;
    }

    this.loading = true;
    this.error = null;
    this.validationErrors = [];

    this.gameService.bulkImportGames(this.selectedFile).subscribe({
      next: (result: BulkImportResult) => {
        this.loading = false;
        this.clearSelectedFile();
        this.dialogRef.close({
          success: true,
          message: result.message,
          insertedCount: result.insertedCount
        });
      },
      error: (err: any) => {
        this.loading = false;
        this.clearSelectedFile();
        if (err.status === 422 && err.error?.errors) {
          this.validationErrors = err.error.errors;
          this.error = `Validation failed: ${err.error.errorCount} error(s) found. No games were created.`;
        } else if (err.error?.message) {
          this.error = err.error.message;
        } else if (err.message) {
          this.error = err.message;
        } else {
          this.error = 'Import failed';
        }
      }
    });
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
